import React, { useState, useEffect } from "react";
import { generateClient } from "aws-amplify/data";
import { list, uploadData, remove, getUrl } from "aws-amplify/storage";
import AuthInterceptor from "../../interceptors/authInterceptor.jsx";
import Layout from "../../components/layout/AdminLayout.jsx";

const client = generateClient();

export default function BannerAdmin() {
  const [text, setText] = useState("");
  const [images, setImages] = useState([]);
  const [newImageFiles, setNewImageFiles] = useState([]);
  const [bannerId, setBannerId] = useState(null);
  const [loading, setLoading] = useState(false);

  // Obtener el banner existente
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const { data: items } = await client.models.Banner.list({
          authMode: "userPool",
        });
        if (items.length > 0) {
          const banner = items[0];
          setBannerId(banner.id);
          setText(banner.text);
        }
        fetchImages(); // Obtener imágenes desde S3
      } catch (error) {
        console.error("Error al obtener el banner:", error);
      }
    };

    fetchBanner();
  }, []);

  // Obtener imágenes desde S3
  const fetchImages = async () => {
    try {
      const filesResult = await list({ path: "Banner/" });
      const files = Array.isArray(filesResult.items) ? filesResult.items : [];
      const imageUrls = await Promise.all(
        files.map(async (file) => {
          const { url } = await getUrl({ path: file.path });
          return { path: file.path, url: url.href };
        }),
      );
      setImages(imageUrls);
    } catch (error) {
      console.error("Error al obtener imágenes del banner:", error);
    }
  };

  // Guardar el banner
  const saveBanner = async () => {
    const banner = {
      id: bannerId,
      text,
    };

    try {
      if (bannerId) {
        await client.models.Banner.update(banner, {
          authMode: "userPool",
        });
      } else {
        console.log("Banner a crear:", banner);
        var result = await client.models.Banner.create(
          {
            titulo: banner.text,
            text: banner.text,
            imageFolder: "Banner/",
          },
          {
            authMode: "userPool",
          },
        );
        console.log("Banner creado:", result);
        setBannerId(result.id);
      }
    } catch (error) {
      console.error("Error al guardar el banner:", error);
      alert("Error al guardar el banner.");
    }
  };

  // Subir nuevas imágenes a S3
  const handleUploadImages = async () => {
    try {
      setLoading(true);

      // Crear un array de promesas para subir las imágenes
      const uploadPromises = newImageFiles.map(async (file) => {
        const filePath = `Banner/${file.name}`;
        await uploadData({ path: filePath, data: file }).result;
        const { url } = await getUrl({ path: filePath });
        return { path: filePath, url: url.href };
      });

      // Esperar a que todas las imágenes se suban y obtener sus URLs
      const newImages = await Promise.all(uploadPromises);

      // Actualizar el estado con las nuevas imágenes
      setImages((prevImages) => [...prevImages, ...newImages]);
      setNewImageFiles([]);
    } catch (error) {
      console.error("Error al subir imágenes:", error);
      alert("Error al subir imágenes.");
    } finally {
      setLoading(false);
    }
  };

  // Eliminar una imagen de S3
  const handleDeleteImage = async (path) => {
    if (window.confirm("¿Seguro que deseas eliminar esta imagen?")) {
      try {
        await remove({ path });
        setImages((prevImages) =>
          prevImages.filter((img) => img.path !== path),
        );
      } catch (error) {
        console.error("Error al eliminar imagen:", error);
        alert("Error al eliminar la imagen.");
      }
    }
  };

  return (
    <Layout>
      <AuthInterceptor>
        <div className="p-4">
          <h2 className="mb-4 text-2xl font-bold">Administrar Banner</h2>

          {/* Texto del Banner */}
          <div className="mb-4">
            <label className="mb-2 block">Texto del Banner:</label>
            <input
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="w-full rounded border p-2"
            />
          </div>

          {/* Subir Imágenes */}
          <div className="mb-4">
            <label className="mb-2 block">Subir Imágenes del Banner:</label>
            <input
              type="file"
              multiple
              onChange={(e) => setNewImageFiles([...e.target.files])}
              className="w-full cursor-pointer rounded border p-2"
            />
            {newImageFiles.length > 0 && (
              <button
                onClick={handleUploadImages}
                className="mt-2 rounded bg-blue-500 px-4 py-2 text-white"
              >
                Subir Imágenes
              </button>
            )}
          </div>

          {/* Mostrar Imágenes */}
          <div className="mb-4">
            <h3 className="mb-2 text-lg font-semibold">Imágenes del Banner:</h3>
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
              {loading ? (
                <p className="text-gray-700">Cargando imágenes...</p>
              ) : (
                images.map((image) => (
                  <div key={image.path} className="group relative">
                    <img
                      src={image.url}
                      alt="Imagen del banner"
                      className="h-40 w-full rounded object-cover shadow"
                    />
                    <button
                      onClick={() => handleDeleteImage(image.path)}
                      className="absolute right-2 top-2 hidden rounded bg-red-600 px-2 py-1 text-xs text-white group-hover:block"
                    >
                      Eliminar
                    </button>
                  </div>
                ))
              )}
            </div>
          </div>

          {/* Guardar Cambios */}
          <button
            onClick={saveBanner}
            className="rounded bg-green-500 px-4 py-2 text-white"
          >
            Guardar
          </button>
        </div>
      </AuthInterceptor>
    </Layout>
  );
}
